import { visit } from '../libs/Visitor'
import { Crawler } from '../types/crawler'
import { DataResponse } from '../types/response'

export const crawler = {
  searchRanking: {
    list() {
      return visit<DataResponse<string[]>>({
        method: 'GET',
        url: 'crawler/searchRanking/list'
      })
    },
    get(id: number) {
      return visit<DataResponse<Crawler.SearchRanking>>({
        method: 'GET',
        url: 'crawler/searchRanking?id=' + id
      })
    },
    delete(id: number) {
      return visit<DataResponse<Crawler.SearchRanking>>({
        method: 'DELETE',
        url: 'crawler/searchRanking/' + id
      })
    },
    download(taskName: string, from: string, to: string) {
      let url = `crawler/searchRanking/download?taskName=${taskName}&from=${from}&to=${to}`
      return visit<string>({
        method: 'GET',
        url,
        responseType: 'blob'
      })
    }
  }
}
